export const galleryImages = [
  {
    id: 1,
    src: '/gallery/image_1.jpeg',
    alt: 'Children reading The Tiny Times magazine',
    title: 'Happy Readers! 📖',
    caption: 'Kids enjoying their weekly dose of fun stories and puzzles!',
    category: 'readers',
    featured: true,
  },
  {
    id: 2,
    src: '/gallery/image_2.jpeg',
    alt: 'Children reading The Tiny Times magazine',
    title: 'Happy Readers! 📖',
    caption: 'Kids enjoying their weekly dose of fun stories and puzzles!',
    category: 'readers',
    featured: true,
  },
  {
    id: 3,
    src: '/gallery/image_3.jpeg',
    alt: 'Children reading The Tiny Times magazine',
    title: 'Happy Readers! 📖',
    caption: 'Kids enjoying their weekly dose of fun stories and puzzles!',
    category: 'readers',
    featured: true,
  },
  {
    id: 4,
    src: '/gallery/image_4.jpeg',
    alt: 'Children reading The Tiny Times magazine',
    title: 'Happy Readers! 📖',
    caption: 'Kids enjoying their weekly dose of fun stories and puzzles!',
    category: 'readers',
    featured: true
  },
  {
    id: 5,
    src: '/gallery/image_5.jpeg',
    alt: 'Children reading The Tiny Times magazine',
    title: 'Happy Readers! 📖',
    caption: 'Kids enjoying their weekly dose of fun stories and puzzles!',
    category: 'readers',
    featured: true,
  },
  {
    id: 6,
    src: '/gallery/image_6.jpeg',
    alt: 'Child reading magazine',
    title: 'Story Time 📚',
    caption: 'Lost in the world of imagination!',
    category: 'readers',
    featured: false,
  },
  {
    id: 7,
    src: '/gallery/image_7.jpeg',
    alt: 'Colorful child artwork',
    title: 'Rainbow Dreams 🌈',
    caption: 'A colorful masterpiece by our young artist!',
    category: 'artwork',
    featured: false,
  },
  {
    id: 8,
    src: '/gallery/image_8.jpeg',
    alt: 'Group of happy children',
    title: 'Reading Club 👧👦',
    caption: 'Our reading club members having a great time!',
    category: 'readers',
    featured: true,
  },
  {
    id: 9,
    src: '/gallery/image_9.jpeg',
    alt: 'Science experiment',
    title: 'Little Scientists 🔬',
    caption: 'Exploring science through fun experiments!',
    category: 'activities',
    featured: false,
  },
  {
    id: 10,
    src: '/gallery/image_10.jpeg',
    alt: 'Children learning together',
    title: 'Learning Together 🎓',
    caption: 'Education meets fun in every issue!',
    category: 'events',
    featured: false,
  },
  {
    id: 11,
    src: '/gallery/image_11.jpeg',
    alt: 'Creative painting activity',
    title: 'Paint Party 🖌️',
    caption: 'Expressing creativity through colors!',
    category: 'artwork',
    featured: false,
  },
  {
    id: 12,
    src: '/gallery/image_12.jpeg',
    alt: 'Team celebration',
    title: 'Team Celebration 🎊',
    caption: 'The Tiny Times team celebrating a milestone!',
    category: 'team',
    featured: false,
  },
];